import React from "react"

export interface TextInputContextType {
  minLength?: number
  maxLength?: number
}

export const TextInputContext = React.createContext<TextInputContextType>({})
